import {
  CheckCircleIcon,
  ClipboardDocumentCheckIcon,
  DocumentPlusIcon,
  PencilIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import {
  ChangesSummary,
  CreatedEntityPattern,
  EventRow,
  EventText,
  EventUser,
  StatusChangePattern,
  Tag,
  UserActionPattern,
} from '@/components/domain-events-v2/shared';
import { RegistryDefinitions } from '@/components/domain-events-v2/types';
import { MatterLink } from '@/components/entity-links';

export const matterEvents: RegistryDefinitions = {
  matter_created: {
    icon: DocumentPlusIcon,
    iconColor: 'text-purple-500',
    priority: 'high',
    render: (event) => {
      const { payload } = event;
      return (
        <CreatedEntityPattern
          event={event}
          entityType="matter"
          entityName={
            <MatterLink entityId={event.matter} variant="badge">
              {payload.matter.name || 'Matter'}
            </MatterLink>
          }
          tag={{ text: 'New Case', color: 'purple' }}
        />
      );
    },
    description: () => 'created this matter',
  },

  matter_updated: {
    icon: PencilIcon,
    iconColor: 'text-gray-400',
    priority: 'low',
    render: (event) => {
      const { payload } = event;
      return (
        <UserActionPattern
          event={event}
          action="updated"
          details={
            payload.diff ? (
              <ChangesSummary diff={payload.diff as Record<string, unknown>} />
            ) : undefined
          }
        >
          <MatterLink entityId={event.matter} variant="badge">
            {payload.matter?.name || 'matter'}
          </MatterLink>
        </UserActionPattern>
      );
    },
    description: () => 'updated matter information',
  },

  matter_status_changed: {
    icon: CheckCircleIcon,
    iconColor: 'text-purple-500',
    priority: 'high',
    render: (event) => {
      const { payload } = event;
      return (
        <StatusChangePattern
          event={event}
          entityType="matter status"
          entityName={
            <MatterLink entityId={event.matter} variant="badge">
              {payload.matter.name || 'Matter'}
            </MatterLink>
          }
          oldStatus={payload.old_status}
          newStatus={payload.new_status}
        />
      );
    },
    description: (event) => {
      const p = event.payload;
      return `changed matter status from ${p.old_status} to ${p.new_status}`;
    },
  },

  matter_retainer_signed: {
    icon: ClipboardDocumentCheckIcon,
    iconColor: 'text-green-500',
    priority: 'high',
    render: (event) => (
      <EventRow>
        <EventUser event={event} />
        <EventText>signed retainer for</EventText>
        <MatterLink entityId={event.matter} variant="badge">
          {event.payload.matter?.name || 'matter'}
        </MatterLink>
        <Tag color="emerald" size="xs">
          Signed
        </Tag>
      </EventRow>
    ),
    description: () => 'marked the retainer as signed',
  },
};
